import React from 'react';
import styles from './HeaderDebts.module.scss';
import SelectCompany from '../SelectCompany';

const HeaderDebts = () => {
  return (
    <div className={styles.root}>
      <SelectCompany />
    </div>
  );
};

export default HeaderDebts;
